//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  props:{
    item:{}
  }
}



// WEBPACK FOOTER //
// ./src/components/goods.vue